import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

// Firebase
import { AngularFireModule } from "@angular/fire";
import { AngularFirestoreModule } from "@angular/fire/firestore";
import { AngularFireStorageModule } from "@angular/fire/storage";
import { AngularFireAuthModule } from "@angular/fire/auth";
import { environment } from "src/environments/environment.prod";
import { LoginComponent } from "./components/login/login.component";
import { ServiceWorkerModule } from "@angular/service-worker";
import { ProfileComponent } from "./components/profile/profile.component";
import { NavbarComponent } from "./components/navbar/navbar.component";
import { DashbaordComponent } from "./components/dashbaord/dashbaord.component";
import { BottomNavbarComponent } from "./components/bottom-navbar/bottom-navbar.component";
import { HttpConfigInterceptor } from "./services/interceptor.service";
import { AuthGuard } from "./services/guards/auth-guard.service";
import { AnalysisComponent } from "./components/analysis/analysis.component";
import { BudgetComponent } from "./components/budget/budget.component";
import { StackedbarComponent } from "./ui/stackedbar/stackedbar.component";
import { TopUsageBarComponent } from "./ui/top-usage-bar/top-usage-bar.component";
import { LineGraphComponent } from "./ui/line-graph/line-graph.component";
import { MainPageComponent } from "./ui/main-page/main-page.component";
import { DisplayProfileComponent } from "./components/display-profile/display-profile.component";
import { UserProfileComponent } from "./components/user-profile/user-profile.component";
import { OwlModule } from "ngx-owl-carousel";
import { ToastrModule } from "ngx-toastr";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { VyasComponent } from "./components/vyas/vyas.component";
import { DiagnosisComponent } from "./components/diagnosis/diagnosis.component";
import { ReferralComponent } from "./components/referral/referral.component";
import { VyasNavbarComponent } from "./components/vyas-navbar/vyas-navbar.component";
import { CreateEditApplianceComponent } from "./components/vyas/create-edit-appliance/create-edit-appliance.component";
import { ApplianceProfileComponent } from "./components/vyas/create-edit-appliance/appliance-profile/appliance-profile.component";
import { ApplianceServiceComponent } from "./components/vyas/create-edit-appliance/appliance-service/appliance-service.component";
import { ApplianceWarrantyComponent } from "./components/vyas/create-edit-appliance/appliance-warranty/appliance-warranty.component";
import { SelectCategoryComponent } from "./components/vyas/create-edit-appliance/select-category/select-category.component";
import { ApplianceDetailsComponent } from "./components/vyas/appliance-details/appliance-details.component";
import { ApplianceProfileDetailComponent } from "./components/vyas/appliance-details/appliance-profile-detail/appliance-profile-detail.component";
import { ApplianceWarrantyDetailsComponent } from "./components/vyas/appliance-details/appliance-warranty-details/appliance-warranty-details.component";
import { ApplianceServiceDetailsComponent } from "./components/vyas/appliance-details/appliance-service-details/appliance-service-details.component";
import { ApplianceHealthDetailsComponent } from "./components/vyas/appliance-details/appliance-health-details/appliance-health-details.component";
import { SupportComponent } from "./components/support/support.component";
import { DiagnosisInitateComponent } from "./components/diagnosis-initate/diagnosis-initate.component";
import { LoaderComponent } from "./ui/loader/loader.component";
import { AngularFirePerformanceModule, PerformanceMonitoringService } from '@angular/fire/performance';
import { BotInfoComponent } from './components/bot-info/bot-info.component';
import { BotDetailsComponent } from './components/bot-info/bot-details/bot-details.component';
import { BotEditComponent } from './components/bot-info/bot-edit/bot-edit.component';
import { EditProfileComponent } from './components/user-profile/edit-profile/edit-profile.component';
import { DashboardRightComponent } from './components/dashbaord/dashboard-right/dashboard-right.component';
import { BotInfoDetailsComponent } from './components/bot-info/bot-details/bot-info-details/bot-info-details.component';
import { HomeDetailsComponent } from './components/bot-info/bot-details/home-details/home-details.component';
import { HomeDetailsEditComponent } from './components/bot-info/bot-edit/home-details-edit/home-details-edit.component';
import { BotInfoEditComponent } from './components/bot-info/bot-edit/bot-info-edit/bot-info-edit.component';
import { UtilityDetailsComponent } from './components/bot-info/bot-details/utility-details/utility-details.component';
import { BotUtilityEditComponent } from './components/bot-info/bot-edit/bot-utility-edit/bot-utility-edit.component';
import { NonRegisterComponent } from './components/non-register/non-register.component';
import { VyasOnboardingComponent } from './components/vyas/vyas-onboarding/vyas-onboarding.component';
import { VyasOnboardingPageOneComponent } from './components/vyas/vyas-onboarding/vyas-onboarding-page-one/vyas-onboarding-page-one.component';
import { VyasOnboardingPageTwoComponent } from './components/vyas/vyas-onboarding/vyas-onboarding-page-two/vyas-onboarding-page-two.component';
import { VyasOnboardingPageThreeComponent } from './components/vyas/vyas-onboarding/vyas-onboarding-page-three/vyas-onboarding-page-three.component';
import { GameBotComponent } from './components/game-bot/game-bot.component';
import { MoreComponent } from './components/more/more.component';
import { TrainBotComponent } from './components/train-bot/train-bot.component';
import { TrainingComponent } from './components/train-bot/training/training.component';
import { TrainingInitateComponent } from './components/train-bot/training-initate/training-initate.component';
import { DiagnosisListComponent } from './components/diagnosis-list/diagnosis-list.component';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ProfileComponent,
    NavbarComponent,
    DashbaordComponent,
    BottomNavbarComponent,
    AnalysisComponent,
    BudgetComponent,
    StackedbarComponent,
    TopUsageBarComponent,
    LineGraphComponent,
    MainPageComponent,
    DisplayProfileComponent,
    UserProfileComponent,
    VyasComponent,
    DiagnosisComponent,
    ReferralComponent,
    VyasNavbarComponent,
    CreateEditApplianceComponent,
    ApplianceProfileComponent,
    ApplianceServiceComponent,
    ApplianceWarrantyComponent,
    SelectCategoryComponent,
    ApplianceDetailsComponent,
    ApplianceProfileDetailComponent,
    ApplianceWarrantyDetailsComponent,
    ApplianceServiceDetailsComponent,
    ApplianceHealthDetailsComponent,
    SupportComponent,
    DiagnosisInitateComponent,
    LoaderComponent,
    BotInfoComponent,
    BotDetailsComponent,
    BotEditComponent,
    EditProfileComponent,
    DashboardRightComponent,
    BotInfoDetailsComponent,
    HomeDetailsComponent,
    HomeDetailsEditComponent,
    BotInfoEditComponent,
    UtilityDetailsComponent,
    BotUtilityEditComponent,
    NonRegisterComponent,
    VyasOnboardingComponent,
    VyasOnboardingPageOneComponent,
    VyasOnboardingPageTwoComponent,
    VyasOnboardingPageThreeComponent,
    GameBotComponent,
    MoreComponent,
    TrainBotComponent,
    TrainingComponent,
    TrainingInitateComponent,
    DiagnosisListComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule, // firestore
    AngularFireAuthModule, // auth
    AngularFirePerformanceModule,
    AngularFireStorageModule,
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: environment.production,
    }), // storage
    OwlModule,
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true,
    },
    { provide: AuthGuard },
    AngularFirePerformanceModule
  ],
  exports: [FormsModule],
  bootstrap: [AppComponent],
})
export class AppModule { }
